import { Component, ElementRef, EventEmitter, Input, OnChanges, SimpleChanges,
         Output, ViewChild
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { RegionLike } from 'app/controls/image-cropper/region';

@Component({
  selector: 'image-zoom',
  templateUrl: './image-zoom.component.html',
  styleUrls: ['./image-zoom.component.scss'],
})

export class ImageZoomComponent implements OnChanges
{
  @Input() public selectedRegion: RegionLike|undefined = undefined;
  @Input() public maxRegion: RegionLike|undefined = undefined;
  @Input() public targetRegion: RegionLike|undefined = undefined;

  @Output() public selectedRegionChange: EventEmitter<RegionLike> =
      new EventEmitter<RegionLike>();

  @ViewChild('zoom')
  private zoom: ElementRef;

  public readonly MAX_ZOOM: number = 0.95;

  constructor(
      private mir: MatIconRegistry,
      private sanitizer: DomSanitizer)
  {
    this.mir.addSvgIcon(
        'glass-minus',
        this.sanitizer.bypassSecurityTrustResourceUrl(
            'assets/img/icons/glass-minus.svg'));
    this.mir.addSvgIcon(
        'glass-plus',
        this.sanitizer.bypassSecurityTrustResourceUrl(
            'assets/img/icons/glass-plus.svg'));
  }

  public ngOnChanges(changes: SimpleChanges): void
  {
    if (changes['selectedRegion']) {
      this.updateZoomInput();
    }
  }

  private updateZoomInput(): void
  {
    this.zoom.nativeElement.value =
      1 - this.selectedRegion.width / this.maxRegion.width;
  }

  private makeZoom(zoom: number): void
  {
    if (zoom < 0) {
      zoom = 0;
    }
    if (zoom > this.MAX_ZOOM) {
      zoom = this.MAX_ZOOM;
    }

    const scale = 1 - zoom;
    const centerX = (this.selectedRegion.x + this.selectedRegion.width / 2);
    const centerY = (this.selectedRegion.y + this.selectedRegion.height / 2);
    const newWidth  = this.maxRegion.width * scale;
    const newHeight = this.maxRegion.height * scale;

    let newX = centerX - newWidth / 2;
    let newY = centerY - newHeight / 2;
    if (newX < 0) {
      newX = 0;
    }
    if (newY < 0) {
      newY = 0;
    }
    if (newX + newWidth > this.targetRegion.width) {
      newX = this.targetRegion.width - newWidth;
    }
    if (newY + newHeight > this.targetRegion.height) {
      newY = this.targetRegion.height - newHeight;
    }
    this.selectedRegion = {
      x: newX,
      y: newY,
      width: newWidth,
      height: newHeight
    };
    this.selectedRegionChange.emit(this.selectedRegion);
    this.updateZoomInput();
  }

  public zoomInputChanged(event: any): void
  {
    this.makeZoom(parseFloat(event.target.value));
  }

  public decreaseZoom(): void
  {
    this.makeZoom(parseFloat(this.zoom.nativeElement.value) - 0.05);
  }

  public increaseZoom(): void
  {
    this.makeZoom(parseFloat(this.zoom.nativeElement.value) + 0.05);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/image-zoom/image-zoom.component.ts